import React, { useEffect, useState } from 'react';
import * as echarts from 'echarts';
import { hoverBG, toolTipBG } from '../../../../components/icons/icons.jsx'
let rpx = window.innerWidth / 2048;
const updateSize = () => {
  rpx = window.innerWidth / 2048;
};
window.addEventListener('resize', updateSize);
console.log('rpx', rpx);

const getSymbolSize = (z) => {
  // 设置最小和最大气泡大小
  const minSize = 5;
  const maxSize = 30;

  // 假设 z 的范围是 0-100
  // 您可以根据实际数据范围调整这个计算公式
  return minSize + (z * (maxSize - minSize) / 40);
};

const optionA = (data) => {
  return {
    grid: {
      left: '8%',
      top: '8%',
      bottom: '10%',
      right: '6%',
      borderColor: 'rgba(0,70,22,0.8)',
      containLabel: true,
    },
    tooltip: {
      backgroundColor: 'rgba(0,0,0,0)',
      padding: 0,
      margin: 0,
      borderWidth: 0,
      extraCssText: `box-shadow: none;`,
      formatter: function (params) {
        const title = params.data[3];
        const reach = params.data[2];
        const importance = params.data[0];
        const willingness = params.data[1];

        return `
          <div style="
            width: 20vw;
            position: relative;
            background-image: url(${toolTipBG});
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
          ">
          <div style="padding: 15px;">
              <div style="
                font-size: 0.8vw;
                color: #fff;
                word-wrap: break-word;
                white-space: normal;
                line-height: 1.4;
                width: 18vw;
                margin: 0 0 15px 0;
                padding: 0;
              ">
                ${title}
              </div>
              <div style="display: flex; justify-content: space-between;font-size: 0.8vw;width: 16vw;">
                <div style="text-align: center;width: 5vw;">
                  <div style="color: #00A32E; margin-bottom: 8px;">Reach</div>
                  <div style="width: 3vw; background: rgba(0, 163, 46, 0.3); padding: 5px 5px; border-radius: 4px;margin: 0 auto;color: #fff;">${reach}%</div>
                </div>
                <div style="text-align: center;width: 5vw;">
                  <div style="color: #00A32E; margin-bottom: 8px;">Importance</div>
                  <div style="width: 3vw; background: rgba(0, 163, 46, 0.3); padding: 5px 5px; border-radius: 4px;margin: 0 auto;color: #fff;">${importance}%</div>
                </div>
                <div style="text-align: center;width: 5vw;">
                  <div style="color: #00A32E; margin-bottom: 8px;">Willingness to pay</div>
                  <div style="width: 3vw; background: rgba(0, 163, 46, 0.3); padding: 5px 5px; border-radius: 4px;margin: 0 auto;color: #fff;">${willingness}%</div>
                </div>
              </div>
            </div>
          </div>
        `;
      },
    },
    xAxis: {
      axisLine: {
        lineStyle: {
          type: 'dashed',
          color: 'rgba(0,147,45,0.9)',
        },
      },
      splitLine: {
        lineStyle: {
          type: 'dashed',
          color: 'rgba(0,70,22,0.8)',
        },
      },
      scale: true,
      name: 'Reach = size of the bubble',
      nameLocation: 'start',
      nameGap: 40,
      nameTextStyle: {
        align: 'left',
        padding: [20, 0, 0, -14],
        verticalAlign: 'top'
      },
      // min: 'dataMin',
      // max: 'dataMax',
    },
    yAxis: {
      axisLine: {
        lineStyle: {
          type: 'dashed',
          color: 'rgba(0,147,45,0.9)',
        },
      },
      splitLine: {
        lineStyle: {
          type: 'dashed',
          color: 'rgba(0,70,22,0.8)',
        },
      },
      scale: true,
      name: 'Willingness to pay',
      // min: 'dataMin',
      // max: 'dataMax',
    },
    series: {
      data: data,
      type: 'scatter',
      symbolSize: function (data) {
        return getSymbolSize(data[2]);
      },
      // emphasis: {
      //   focus: 'series',
      //   label: {
      //     show: true,
      //     formatter: function(param) {
      //       return param.data[3];
      //     },
      //     position: 'top',
      //   },
      // },
      itemStyle: {
        shadowBlur: 5,
        shadowColor: 'rgb(0,178,47)',
        // shadowOffsetY: 5,
        color: 'rgb(0,162,46)',
      },
      selectedMode: 'single',
      select: {
        itemStyle: {
          color: 'rgb(253,186,56)',
          shadowColor: 'rgb(253,186,56)',
        },
      },
    },
    title: {
      text: 'Importance',
      top: '89%',
      right: '0',
      textStyle: {
        color: 'rgba(0,147,45,0.9)',
        fontSize: 12,
        fontWeight: 'normal',
      }
    }
  };
};


const optionB = (data) => {
  data = data.map(i => {
    return {
      showName: i.name,
      value: i.value,
      id: i.id,
    };
  });
  return {
    tooltip: {
      trigger: 'axis',
      // axisPointer: {
      //   type: 'shadow'
      // },
      backgroundColor: 'rgba(0,0,0,0.9)',
      borderColor: '#10450d',
      color: '#fff',
      formatter: function(params) {
        let dataStr = ''
        dataStr = `<div style="color: #fff;font-size: 0.8vw;">
        <div>${params[0].data.showName}</div></br>
        <div style="display: flex;align-items: center;">
          <span style="display:inline-block;width:10px;height:10px;background-color:#489f40;float: left;padding:5px;"></span>
          <div style="float: left;line-height: 10px;margin:auto 10px;">${params[0].data.value}%</div>
        </div>
        </div>`
        return dataStr
      },
    },
    grid: {
      left: '250',
      top: '0',
      bottom: '30',
      right: '35',
      borderColor: 'rgba(0,70,22,0.8)',
    },
    xAxis: {
      max: 'dataMax',
      show: false,
    },
    yAxis: {
      type: 'category',
      axisLabel: {
        formatter: function (index) {
          return data[index].showName;
        },
        color: '#fff',
        width: '220',
        overflow: 'break',
        align: 'left',
        padding: [0,150,0,-230],
        color: '#00b730',
        fontSize: 16*rpx,
        lineHeight: 18*rpx,
        // formatter: function (index) {
        //   const text = data[index].showName;
        //   // return `{labelBg|${text.slice(0, 22)+'...'}}`
        //   // if (text.length > 10) {
        //   //   // 长文本分两行显示
        //   //   const midPoint = Math.floor(text.length / 2);
        //   //   const firstLine = text.slice(0, midPoint);
        //   //   const secondLine = text.slice(midPoint);
        //   //   return `{labelBg|${firstLine}}`;
        //   // }
        //   // return '{labelBg|' + text + '}';
        //   const maxWidth = 30*rpx;
        //   const rows = [];
        //   text.split(' ').forEach(word => {
        //     if (rows.length === 0) {
        //       rows.push(word);
        //     } else {
        //       if (rows[rows.length - 1].length + word.length + 1 <= maxWidth) {
        //         rows[rows.length - 1] = rows[rows.length - 1] + ' ' + word;
        //       } else {
        //         rows.push(word);
        //       }
        //     }
        //   });
        //   return '{labelBg|' + rows[0] + '\n' + rows[1] + '...}'
        // },
        // rich: {
        //   labelBg: {
        //     padding: [0,0],
        //     color: '#00b730',
        //     fontSize: 14*rpx,
        //     backgroundColor: '#10450d',
        //     align: 'left',
        //     verticalAlign: 'middle',
        //     height: 12,
        //     overflow: 'break',
        //     lineHeight: 10,
        //     width: 150*rpx,
        //     textOverflow: 'ellipsis',
        //     breakWord: true
        //   }
        // }
      },
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
    },
    dataZoom: [{
      type: 'slider',
      show: true,
      yAxisIndex: [0],
      width: 30,
      right: '0',
      startValue: data.length,
      endValue: data.length -5,
      handleSize: 0,  // 隐藏手柄
      showDetail: false,
      backgroundColor: 'rgba(1,76,17,0.2)',  // 滚动条背景色
      fillerColor: 'rgba(0,183,48,0.4)',     // 选中范围的颜色
      borderColor: 'transparent',
      zoomLock: true,  // 锁定缩放比例
      moveHandleSize: 200,
      brushSelect: false,
      handleStyle: {
        color: '#014C11',
        borderWidth: 0,
        borderCap: 'square',
      },
      selectedDataBackground: {
        height: 200,
        lineStyle: {
          color: '#014C11'
        },
        areaStyle: {
          color: '#014C11'
        }
      },
    }],
    series: [
      {
        data,
        type: 'bar',
        itemStyle: {
          color: '#489f40',
        },
        selectedMode: 'single',
        select: {
          itemStyle: {
            color: '#e7ca6c',
          },
        },
        // barWidth: 40,
        barCategoryGap: '40%',
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            // return data[params].name;
          },
          backgroundColor: 'rgba(0,0,0,0.7)',
          borderWidth: 0,
          textStyle: {
            color: '#fff'
          }
        },
      },
    ],
  };
};

const optionC = (data, color, typeIndex) => {
  return {
    color: color,
    title: {
      text: data[0].value + (typeIndex == 0 ? '%' : '%'),
      left: 'center',
      top: '42%',
      textStyle: {
        color: color,
        fontSize: 16,
        align: 'center',
      },
    },
    series: [
      {
        data,
        type: 'pie',
        radius: ['75%', '90%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
        },
      },
    ],
  };

};


const optionD = (data, color) => {
  const xdata = data.map(i => i.response);
  const ydata = data.map(i => i.percent);
  const color1 = 'rgba(' + color[0] + ',' + color[1] + ',' + color[2] + ')';
  const color2 = 'rgba(' + color[0] + ',' + color[1] + ',' + color[2] + ',0.35)';
  return {
    tooltip: {
      trigger: 'axis',
      formatter: '{b}: {c}%'
    },
    color: color1,
    // barWidth: 40,
    xAxis: {
      // show:false,
      data: xdata,
      axisLine: {
        symbol: ['none', 'arrow'],
        symbolSize: [6, 6],
        lineStyle: {
          color: color2,
        },
      },
      axisLabel: {
        show: false,
      },
      axisTick: {
        show: false,
      },
    },
    yAxis: {
      type: 'value',
      axisLine: {
        show: true,
        symbol: ['none', 'arrow'],
        symbolSize: [6, 6],
        lineStyle: {
          color: color2,
        },
      },
      splitLine: {
        show: true,
        lineStyle: {
          type: 'solid',
          color: ['#011c03', color2, color2, color2],
        },
      },
    },
    grid: {
      left: '5',
      top: '0',
      bottom: '15',
      right: '5',
    },
    series: [{
      data: ydata,
      type: 'bar',
      itemStyle: {
        normal: {
          //这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
          barBorderRadius: 8,
        },
      },
      barCategoryGap: '40%',
      barMaxWidth: '50',
    }],
  };
};


export default {
  optionA,
  optionB,
  optionC,
  optionD,
};